import {
  Box,
  Card,
  CardContent,
  Typography,
  Divider,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { Building2, Mail, Phone, User } from "lucide-react";
import { useEffect, useState } from "react";
import { unwrapResult } from "@reduxjs/toolkit";
import { useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { getMoveService } from "../../redux/action/move-service";

interface MoveData {
  moves:any
}
const MovingCompanyInfo:React.FC<MoveData> = ({moves}) => {
  const dispatch = useDispatch();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const companyName = moves?.[0]?.carrier?.business_name ;
  const contactPerson = moves?.[0]?.carrier?.customer_service_phone;
  const phoneNumber = moves?.[0]?.carrier?.business_phone ;
  const email = moves?.[0]?.carrier?.email ;
  
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3, paddingTop: '20px' }}>
      <Box sx={{ width:isMobile ? "100%" : "70%" }}>
        <Card sx={{ boxShadow: 3, borderRadius: 2 }}>
          <CardContent>
            <Typography variant="h6" sx={{ fontWeight: "bold", mb: 2 }}>
              Moving Company Information
            </Typography>

            <Divider sx={{ mb: 2 }} />

            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 2 }}>
              <Box sx={{ flex: '1 1 calc(50% - 16px)', minWidth: '200px' }}>
                <Box
                  sx={{ display: "flex", alignItems: "center", gap: 2, mb: 2 }}
                >
                  <Building2 className="h-5 w-5 text-blue-600" />
                  <div>
                    <Typography variant="body2" sx={{ fontWeight: "medium" }}>
                      {companyName ? `${companyName}`:"Not available" }
                    </Typography>
                  </div>
                </Box>
              </Box>

              <Box sx={{ flex: '1 1 calc(50% - 16px)', minWidth: '200px' }}>
                <Box
                  sx={{ display: "flex", alignItems: "center", gap: 2, mb: 2 }}
                >
                  <User className="h-5 w-5 text-blue-600" />
                  <div>
                    <Typography variant="body2" sx={{ color: "gray" }}>
                      Customer Service Phone
                    </Typography>
                    <Typography variant="body1" sx={{ fontWeight: "medium" }}>
                      {contactPerson ? `+1${contactPerson}`:"Not available" }
                    </Typography>
                  </div>
                </Box>
              </Box>

              <Box sx={{ flex: '1 1 calc(50% - 16px)', minWidth: '200px' }}>
                <Box
                  sx={{ display: "flex", alignItems: "center", gap: 2, mb: 2 }}
                >
                  <Phone className="h-5 w-5 text-blue-600" />
                  <div>
                    <Typography variant="body2" sx={{ color: "gray" }}>
                      Phone Number
                    </Typography>
                    <Typography variant="body1" sx={{ fontWeight: "medium" }}>
                      {phoneNumber ? `+1${phoneNumber}`:"Not available" }
                    </Typography>
                  </div>
                </Box>
              </Box>

              <Box sx={{ flex: '1 1 calc(50% - 16px)', minWidth: '200px' }}>
                <Box
                  sx={{ display: "flex", alignItems: "center", gap: 2, mb: 2 }}
                >
                  <Mail className="h-5 w-5 text-blue-600" />
                  <div>
                    <Typography variant="body2" sx={{ color: "gray" }}>
                      Email
                    </Typography>
                    <Typography variant="body1" sx={{ fontWeight: "medium" }}>
                    {email ? `${email}`:"Not available" }
                    </Typography>
                  </div>
                </Box>
              </Box>
            </Box>
          </CardContent>
        </Card>
      </Box>
    </Box>
  );
};

export default MovingCompanyInfo;